import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextNavTreeComponent } from './context-nav-tree.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ContextNavTreeComponent],
  exports: [
    ContextNavTreeComponent
  ]
})
export class ContextNavTreeModule { }
